import { render } from "./SafetyDialogFormView.vue?vue&type=template&id=11c3796a&scoped=true&ts=true"
import script from "./SafetyDialogFormView.vue?vue&type=script&lang=ts"
export * from "./SafetyDialogFormView.vue?vue&type=script&lang=ts"

import "./SafetyDialogFormView.vue?vue&type=style&index=0&id=11c3796a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c3796a"]])

export default __exports__